export const searchFormOption = function () {
  return [
    {
      prop: "orgId",
      label: "所属机构",
      type: "cascader",
      placeholder: "请选择所属机构",
      propConfig: {
        children: "children",
        label: "orgName",
        value: "id",
        checkStrictly: true,
        emitPath: false,
      },
      options: this.orgOption,
    },
    {
      prop: "date",
      label: "退单时间",
      type: "range-date",
    },
    {
      prop: "keywords",
      label: "关键字",
      type: "input",
      placeholder: "请输入服务单号、车牌号、被服务人",
    },
  ];
};

export default {};
